import React from 'react';
import Page from './Page';

export default function Error404() {
  return (
    <Page>
      <h1>Page not found</h1>
    </Page>
  );
}
